import styled from 'styled-components';
import { variables } from '../../../../styles/variables';
import { SubjectCardFormElementFontStyle } from '../../../../styles/sharedUIElemStyles';
import { Input } from 'react-inv-forms';

const { TextArea } = Input;

const CustomTextArea = styled(TextArea)`
  opacity: 1;
  border-radius: 4px;
  border: 1px solid ${variables.colorBorder};
  padding: 7px 14px;
  font-family: inherit;
  ${SubjectCardFormElementFontStyle};
  &::placeholder {
    opacity: 0.3;
  }
  &:hover {
    border: 1px solid ${variables.colorDecorator};
  }
  &.ant-input:focus,
  &.ant-input-focused {
    border-color: ${variables.colorDecorator};
    box-shadow: 0 0 0 2px rgba(139, 35, 29, 0.1);
  }
  &.ant-input.ant-input-disabled {
    color: rgba(0, 0, 0, 0.7);
    cursor: text;
  }
  .anticon.ant-input-textarea-clear-icon {
    font-size: 16px;
    color: ${variables.colorDecorator};
  }
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    border-color: ${variables.colorWhite};
    background: ${variables.colorWhite};
  }
  &::-webkit-scrollbar-thumb {
    background: ${variables.colorBorder};
  }
  span.anticon-check {
    color: ${variables.colorDecorator};
  }
`;

export { CustomTextArea as TextArea };
